import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import { Question } from '../shared/question.model';
import * as QuestionListActions from './store/question-list.actions';
import * as fromApp from '../store/app.reducers';

@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.css']
})
export class QuestionListComponent implements OnInit {
  questionListState: Observable<{questions: Question[]}>;

  constructor(private store: Store<fromApp.AppState>) { }

  ngOnInit() {
    this.questionListState = this.store.select('questionList');
  }

  onEditItem(index: number) {
    this.store.dispatch(new QuestionListActions.StartEdit(index));
  }
}



// WEBPACK FOOTER //
// ./src/app/question-list/question-list.component.ts